import { Box, Text } from '@nimbus-ds/components';
import { InteractiveListPriv } from '@tiendanube/components';
import { ImageItemStratus, VirtualInteractiveList } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { ProductHiddenAndWithoutStock } from 'domains/Catalog/Products/pages/components';
import { SelectProductListItemProps } from '../types';

function SelectProductListItem({
  onChange,
  onReached,
  products,
  isRefreshing = false,
  trimTitle = false,
  selectedProducts,
  reachedLimit = false,
  disabledProducts = [],
  disabledAsSelected = false,
  showVariants = false,
}: SelectProductListItemProps) {
  const t = useTranslationCatalog();
  return (
    <VirtualInteractiveList
      totalCount={products.length}
      endReached={onReached}
      showFooter={isRefreshing}
      itemContent={(index) => {
        const isDisabled = disabledProducts.includes(products[index].id);
        const isSelected =
          selectedProducts.some((prod) => prod.id === products[index].id) ||
          (disabledAsSelected ? isDisabled : false);

        const toDisable = isDisabled || (reachedLimit && !isSelected);
        return (
          <InteractiveListPriv.CheckItem
            blockLeft={
              <ImageItemStratus
                id={products[index].id}
                title={products[index].name}
                imageUrl={products[index].imageUrl}
                imageWidth="56px"
                appearance="default"
                bold={false}
                trimTitle={trimTitle}
              >
                {showVariants && (
                  <Box>
                    <Text>
                      {t('products.selectProductList.variants', {
                        count: products[index].variants.length,
                      })}
                    </Text>
                  </Box>
                )}
                {!showVariants && (
                  <ProductHiddenAndWithoutStock
                    isVisible={products[index].visible}
                    hasStock={products[index].stock}
                    productId={products[index].id}
                  />
                )}
              </ImageItemStratus>
            }
            disabled={toDisable}
            key={index}
            title=""
            name={products[index].id}
            checked={isSelected}
            onChange={onChange}
          />
        );
      }}
    />
  );
}

export default SelectProductListItem;
